import PropTypes from 'prop-types';

import { useAppSelector } from '@/redux';
import { getAttributeId, isProductTtc, isPrimeurCode, getCurrentItemPrices } from '@/utils/productUtils';

import MillesimaPrice from '@/components/common/price/MillesimaPrice';

import styles from './ProductPrice.module.scss';
import { STORE_ID } from '@/constants/stores';

export const ProductPrice = ({
  product,
  currentItem,
  displayUnitBloc = true,
  customClass = '',
  isMobile,
  customClassPrice = undefined,
  showVat = true
}) => {
  const isAlert = getAttributeId(product, 'alerte_o_n') === '1';

  const storeId = useAppSelector(({ root }) => root.storeConf?.storeId);
  const isEc = useAppSelector(({ user }) => !!user?.content?.isEc);

  // eslint-disable-next-line camelcase
  if ((product?.exclusive_cellar && !isEc) || isAlert || !product?.display) {
    return null;
  }

  const isTtc = isProductTtc(product, currentItem);
  const displayPriceLiter = [STORE_ID.DEUTSCHLAND, STORE_ID.OSTERREICH].includes(storeId);

  const { priceLiter, unitPrice, listPrice, offerPrice, htPrice } = getCurrentItemPrices(currentItem, product);
  const isReduce = offerPrice !== listPrice && offerPrice > 0;

  const classNamePrice = [
    styles['offer-price'],
    customClassPrice?.listPrice ? '' : (isMobile ? '' : styles.desktop),
    isReduce && styles['is-reduce']
  ].filter(Boolean).join(' ');

  return (
    <div className={`${styles.container} ${customClass}`} data-test-id="product-price">

      <MillesimaPrice
        value={offerPrice}
        vat={{
          display: showVat,
          included: isTtc
        }}
        className={{
          value: classNamePrice,
          vat: styles['tax-mention'],
          container: customClassPrice?.listPrice ?? ''
        }}
      />

      {isReduce && (
        <MillesimaPrice
          value={listPrice}
          strikeout
          className={{ container: styles['list-price'] }}
        />
      )}

      {displayUnitBloc && (
        <MillesimaPrice value={displayPriceLiter ? priceLiter : unitPrice}
          unit={{
            display: true,
            type: displayPriceLiter ? 'liter' : 'unit'
          }}
          className={{ container: styles['below-price-bloc'] }}
        />
      )}

      {isTtc && isPrimeurCode(getAttributeId(product, 'in_stock')) && htPrice > 0 && (
        <MillesimaPrice value={htPrice}
          displayHt={true}
          className={{
            container: customClassPrice?.htPrice ? customClassPrice.htPrice : styles['below-price-bloc']
          }}
        />
      )}
    </div>
  );
};

ProductPrice.propTypes = {
  product: PropTypes.object.isRequired,
  currentItem: PropTypes.object.isRequired,
  displayUnitBloc: PropTypes.bool,
  customClass: PropTypes.string,
  isMobile: PropTypes.bool,
  customClassPrice: PropTypes.object,
  showVat: PropTypes.bool
};

export default ProductPrice;
